import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener('blur', this.uppercaseTeam.bind(this))
  }
  
  uppercaseTeam(e) {
    if (e.target.value.trim()) {
      e.target.value = e.target.value.trim().toUpperCase()
    }
  }
}
